import { 
  GUIDELINE_USER_ROLE_REQUEST,
  GUIDELINE_USER_ROLE_SUCCESS,
  GUIDELINE_USER_ROLE_EMPTY,
  GUIDELINE_USER_ROLE_ERROR,

  GUIDELINE_USER_ROLE_ACCEPT,
  GUIDELINE_USER_ROLE_REJECT,
  GUIDELINE_USER_ROLE_CHANGE_REQUEST,
  GUIDELINE_USER_ROLE_APPROVE,
} from '@/store/actions/guideline_user_role'
 
import Api from '@/services/Api'

const state = {
  status: '',
  logs: []
};


const getters = {
};

const actions = {
  [GUIDELINE_USER_ROLE_ACCEPT]: ({commit, dispatch}, args) => {
    return new Promise((resolve, reject) => {
      commit(GUIDELINE_USER_ROLE_REQUEST)

      Api().post('/guideline-users-role-accept/' + args.guideline.id, {role: args.role})
      .then(function (response) {
        commit(GUIDELINE_USER_ROLE_SUCCESS, response);
        resolve(response);
      })
      .catch(function (error) {
        commit(GUIDELINE_USER_ROLE_ERROR);
        reject(error);
      });
    });
  },

  [GUIDELINE_USER_ROLE_REJECT]: ({commit, dispatch}, args) => {
    return new Promise((resolve, reject) => {
      commit(GUIDELINE_USER_ROLE_REQUEST)

      Api().post('/guideline-users-role-reject/' + args.guideline.id, { role: args.role, comment: args.comment })
      .then(function (response) {
        commit(GUIDELINE_USER_ROLE_SUCCESS, response);
        resolve(response);
      })
      .catch(function (error) {
        commit(GUIDELINE_USER_ROLE_ERROR);
        reject(error);
      });
    });
  },

  [GUIDELINE_USER_ROLE_CHANGE_REQUEST]: ({commit, dispatch}, args) => {
    return new Promise((resolve, reject) => {
      commit(GUIDELINE_USER_ROLE_REQUEST)

      Api().post('/guideline-users-role-change-request/' + args.guideline.id, { role: args.role, comment: args.comment, changeRequest: args.changeRequest })
      .then(function (response) {
        commit(GUIDELINE_USER_ROLE_SUCCESS, response);
        resolve(response);
      })
      .catch(function (error) {
        commit(GUIDELINE_USER_ROLE_ERROR);
        reject(error);
      });
    });
  },

  [GUIDELINE_USER_ROLE_APPROVE]:({commit, dispatch}, args) => {
    return new Promise((resolve, reject) => {
      commit(GUIDELINE_USER_ROLE_REQUEST)

      Api().post('/guideline-users-role-change-approve/' + args.guideline.id, { role: args.role, userId: args.value })
      .then(function (response) {
        commit(GUIDELINE_USER_ROLE_SUCCESS, response);
        resolve(response);
      })
      .catch(function (error) {
        commit(GUIDELINE_USER_ROLE_ERROR);
        reject(error);
      });
    });
  }, 
};

const mutations = {
  [GUIDELINE_USER_ROLE_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [GUIDELINE_USER_ROLE_SUCCESS]: (state) => {
    state.status = 'success';
  },
  [GUIDELINE_USER_ROLE_EMPTY]: (state) => {
    state.status = 'empty';
  },
  [GUIDELINE_USER_ROLE_ERROR]: (state) => {
    state.status = 'error';
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
}
